import { useState } from "react";
import { useNavigate } from "react-router-dom";

/* API */
import { api } from "../api";

/* CSS */
import AuthHeader from '../components/layout/AuthHeader';
import shared from '../styles/shared.module.css';
import styles from "./ForgotPasswordPage.module.css";

/* Icons */
import exclamation from '../assets/icons/exclamation_red.svg';

const ForgotPasswordPage = () => {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            setError("");
            await api.post('/auth/forgot-password', { email });
            // Reuse the signup code screen, but tell it we're in "reset" mode
            navigate('/checkemail', { state: { email, mode: 'reset' } });
        } catch (err) {
            console.error("Error requesting password reset: ", err);
            setError(err.message || "Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {/* Header */}
            <AuthHeader showCancel={false} />

            {/* Body */}
            <div className={shared.authBody}>
                {/* Greetings title */}
                <div className={shared.authTitleWrapper}>
                    <div className={shared.authTitle}>
                        Reset your password
                    </div>
                    <div className={shared.authSubtitleWrapper}>
                        <div className={shared.authSubTitleText}>
                            Remembered your password?
                        </div>
                        <div
                            className={shared.authSubTitleToggle}
                            onClick={() => navigate('/login')}
                        >
                            Log in
                        </div>
                    </div>
                </div>

                {/* Main input */}
                <div className={shared.authBodyInput}>
                    <form noValidate onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                        {/* Email */}
                        <div className={shared.authField}>
                            <div className={shared.authFieldLabel}>
                                Enter your account email and we'll send you a reset code
                            </div>

                            <input
                                type="email"
                                name="email"
                                autoComplete="email"
                                className={shared.authFieldInput}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        {/* Error message */}
                        {error && (
                            <div className={styles.error}>
                                <img
                                    src={exclamation}
                                    alt="Error"
                                    className={styles.errorIcon}
                                />
                                <div className={styles.errorMessage}>
                                    {error}
                                </div>
                            </div>
                        )}

                        {/* Submit button */}
                        <button
                            type="submit"
                            className={`${shared.authButton} ${isLoading ? shared.buttonLoading : ''}`}
                        >
                            <div className={shared.buttonContent}>
                                {isLoading ? "Sending..." : "Send reset code"}
                                {isLoading && <span className={shared.spinner}></span>}
                            </div>
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ForgotPasswordPage;
